import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enum";
import { defaultTemplateState } from "./templates.state";
import { fetchTaxInfoListAsync } from "../tax-info";
import { fetchMultipleTemplatesAsync, fetchSingleTemplateAsync } from "./templates.actions";


const templateSlice = createSlice({
    initialState: defaultTemplateState,
    name: "template",
    reducers: {
        clearMultipleTemplatesSync: (state) => {
            state.multiple_teplates_list = defaultTemplateState["multiple_teplates_list"]
        },
        clearSingleTemplateSync: (state) => {
            state.single_template = defaultTemplateState["single_template"]
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMultipleTemplatesAsync.pending, (state) => {
            state.multiple_teplates_list.loading = LoadState.pending
        })
        // action: PayloadAction<{ data: ITaxInfo[], count: number }
        builder.addCase(fetchMultipleTemplatesAsync.fulfilled, (state, action) => {
            state.multiple_teplates_list.loading = LoadState.succeeded
            state.multiple_teplates_list.data = action.payload.data
            state.multiple_teplates_list.count = action.payload.count
            state.multiple_teplates_list.error = null
        })
        builder.addCase(fetchMultipleTemplatesAsync.rejected, (state, action) => {
            state.multiple_teplates_list.error = action.error.message as string
        })




        builder.addCase(fetchSingleTemplateAsync.pending, (state, action) => {
            state.single_template.loading = LoadState.pending
        })
        builder.addCase(fetchSingleTemplateAsync.fulfilled, (state, action) => {
            state.single_template.loading = LoadState.succeeded
            state.single_template.data = action.payload
            state.single_template.error = null
        })
        builder.addCase(fetchSingleTemplateAsync.rejected, (state, action) => {
            state.single_template.error = action.error.message as string
        })
    },
});

export const templateReducer = templateSlice.reducer;
export const { clearMultipleTemplatesSync, clearSingleTemplateSync } = templateSlice.actions;
